<div
  (click)="onBuyerCardClick()"
  [ngClass]="buyerCardClass"
  class="buyer-card {{ showSimulation ? 'simulated' : 'nonSimulated' }}">
  <div class="top-bar">
    <img
      [alt]="cohort.buyer.name"
      [ngClass]="cohort.buyer.shortName"
      [src]="getOpenAssetURL(cohort.buyer.shortName, 'logo.svg')" />
    <div class="total-annual-value">
      Estimated Annual Revenue:
      <div class="value">
        {{ annualRevenue | currency: 'USD' }}
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="info-section">
    <div class="overview-terms">Payment Summary</div>
    <div class="terms-subtitle bold">
      These payments are based on the current data that is available. They are subject to change based on market
      conditions, verification of forested land, and the terms of your contract.
    </div>
    <div class="info">
      <div class="info-left">Frequency of Payments</div>
      <div class="info-right">
        <span>{{ paymentFrequency }}</span>
      </div>
    </div>
    <div *ngIf="!showSimulation || basePayment === fixedPayment" class="info">
      <div class="info-left">Estimated Payment</div>
      <div class="info-right">
        <span class="paymentAmount">
         {{ baseValuePerYear / (12 / cohort.payPeriodCadence) | currency: 'USD' }}
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="
              'This is your estimated payment.  Your actual payment will follow the frequency listed above, and can change based on your responses to periodic reporting.'
            "
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
      </div>
    </div>
    <div *ngIf="showSimulation && fixedPayment && basePayment !== fixedPayment" class="info">
      <div class="info-left">Estimated Payment During Fixed-Rate Period</div>
      <div class="info-right">
        <span class="fixed-period-payment">
          {{ fixedPayment | currency: 'USD' }}
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="
              'This is your estimated payment during the promotion period. Your actual payment will follow the frequency listed above, and can change based on your responses to periodic reporting.'
            "
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
      </div>
    </div>
    <div *ngIf="showSimulation && basePayment !== fixedPayment" class="info">
      <div class="info-left">Estimated Payment During Variable-Rate Period</div>
      <div class="info-right">
        <span class="variable-period-payment">
          Approx ~{{ basePayment | currency: 'USD' : 'symbol' : '1.0-0' }}
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="
              'This is your estimated payment during the variable-rate period. Your actual payment will follow the frequency listed above, and can change based on your responses to periodic reporting.'
            "
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
      </div>
    </div>
    <div class="info">
      <div class="info-left">Total Payments Through {{ twentyYearMark }}</div>
      <div class="info-right">
        <span class="twenty-year-projection">
          Approx ~{{ getRoundedValue(twentyYearProjection) | currency: 'USD' : 'symbol' : '1.0-0' }}
          <fa-icon
            #tooltip1="matTooltip"
            (click)="tooltip1.toggle()"
            [icon]="['far', 'circle-info']"
            [matTooltip]="
              'This is your simulated projection for your entire contract term. Your actual payment will follow the frequency listed above, and can change based on your responses to periodic reporting or on market performance.'
            "
            class="blue"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"></fa-icon>
        </span>
      </div>
    </div>
    <div class="selected-container">
      <button mat-stroked-button color="primary" class="payment-details" (click)="openDetails()">Payment Schedule
      </button>
    </div>
  </div>
  @if (showSimulation) {
    <mat-divider></mat-divider>
    <div class="info-section">
      <div class="overview-terms">Market Simulator</div>
      <div class="terms-subtitle">
        This simulator allows you to see how your revenue could be impacted by market changes.
        Use the slider to simulate what your total potential earnings could be.
      </div>
      <div class="info">
        <div class="info-left">
          <div>Carbon Price Rate of Change</div>
          <div class="slider-div">
            <mat-slider class="simulation-slider" max="15" min="-5" step="1">
              <input
                matSliderThumb
                (input)="newSliderValue(ngSliderThumb.value)"
                #ngSliderThumb="matSliderThumb"
                data-cy="rate-slider"
                value="0" />
            </mat-slider>
          </div>
        </div>
        <div class="info-right simulation-slider-div">
          <span>%</span>
          <span data-cy="slider-value">{{ ngSliderThumb.value }}</span>
        </div>
      </div>
      <div class="info">
        <div class="info-left">
          Simulated Projection Through
          {{ twentyYearMark }}
        </div>
        <div class="info-right">
          <span class="twenty-year-projection">
            {{ simulatedTwentyYearProjection | currency: 'USD' }}
            <fa-icon
              #tooltip1="matTooltip"
              (click)="tooltip1.toggle()"
              [icon]="['far', 'circle-info']"
              [matTooltip]="
                'This is your simulated projection for your entire contract term. This is based on the current carbon price and the rate you selected in the slider above. This is not a guarantee of your actual revenue.'
              "
              class="blue"
              matTooltipClass="fc-tooltip"
              matTooltipPosition="right"></fa-icon>
          </span>
        </div>
      </div>
    </div>
  }
  <mat-divider></mat-divider>
  <div class="terms">
    <div class="overview-terms">Overview of Terms</div>
    <div class="term-list">
      <ul class="terms">
        <li>{{ cohort.terms1 }}</li>
        <li *ngIf="cohort.terms2">{{ cohort.terms2 }}</li>
        <li *ngIf="cohort.terms3">{{ cohort.terms3 }}</li>
      </ul>
    </div>
    <a *ngIf="cohort.termsUrl" [href]="cohort.termsUrl" class="fc-link" target="_blank">
      <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" class="blue"></fa-icon>
      See additional {{ cohort.buyer.name }} terms
    </a>
  </div>
  <div class="selected-container">
    @if (cohort === selectedCohort) {
      <div>
        <fa-icon [icon]="['fas', 'check']" class="green size-20" title="Is Active"></fa-icon>
        <div>Selected</div>
      </div>
    } @else {
      <button color="primary" mat-stroked-button>Select</button>
    }
  </div>
</div>
